import { TextSelection } from 'prosemirror-state';
export const findNode = (state, predicate) => {
    let found;
    state.doc.descendants((node, offset) => {
        if (predicate(node)) {
            found = { node, offset };
        }
        if (found)
            return false;
    });
    return found;
};
export const setNodeAttrById = (view, nodeType, id, newAttrs = {}) => {
    const { offset, node: imageNode } = findNode(view.state, node => node.attrs.id === id);
    const tr = view.state.tr.setNodeMarkup(offset, nodeType, newAttrs);
    const resolvedPos = tr.doc.resolve(offset + imageNode.nodeSize);
    const selection = new TextSelection(resolvedPos);
    tr.setSelection(selection).scrollIntoView();
    view.dispatch(tr);
    view.focus();
};
//# sourceMappingURL=node.js.map